// Imports list page (CHG-1260 / ITER-3377).
//
// Thin per the v8 brief: page file ≤20 LOC body, all configuration in
// @generated/screens. Future generator regenerates importBatchListConfig
// from import-batch.entity-hint.yaml (CHG-1235) without touching this file.
//
// CHG-1260 addition: floating "New import" trigger button + conditional
// ImportMapWizard mount. The wizard runtime is from CHG-1247 (the 2 custom-
// render components used by step "map" + step "preview" are also shipped
// in this CHG — see apps/dashboard-v2/src/wizards/components/). Additive
// only — ListPage and import-batch-list config UNCHANGED.
//
// Spec: specs/tier-05-experience/imports-v2.cross-screen.yaml.

import { ListPage } from "../components/composition";
import { importBatchListConfig } from "../generated/screens/import-batch-list";
import { ImportMapWizard } from "../wizards/import-map.generated";
import { WizardTriggerButton } from "../wizards/WizardTriggerButton";
import { useWizard } from "../wizards/useWizard";
import { wizardRegistry } from "../wizards/wizardRegistry";

export function Imports() {
  const wizard = useWizard("import-map");
  return (
    <>
      <ListPage config={importBatchListConfig} />
      <WizardTriggerButton
        label="New import"
        onClick={wizard.open}
        requirePermission={wizardRegistry["import-map"].manifest.trigger.permission}
        testId="trigger-import-map"
      />
      <ImportMapWizard open={wizard.isOpen} onClose={wizard.close} />
    </>
  );
}
